
import React from 'react';
import { CalculatorIcon } from 'lucide-react';

const CalculatorHero: React.FC = () => {
  return (
    <section className="bg-brand-lightBlue pt-36 pb-16 md:pt-40 md:pb-24 relative">
      <div className="absolute inset-0 opacity-15">
        <img 
          src="https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d" 
          alt="Business background" 
          className="w-full h-full object-cover"
        />
      </div>
      <div className="container relative z-10">
        <div className="text-center max-w-3xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold text-black mb-6">
            Bereken jouw prijs per warme afspraak
          </h1>
          <p className="text-black text-lg mb-8">
            Met onze calculator weet je exact wat je maandbudget moet zijn — realistisch en transparant.
          </p>
          <a href="#calculator-form" className="inline-flex items-center gap-2 btn-primary">
            <CalculatorIcon size={20} />
            Start mijn berekening
          </a>
        </div>
      </div>
    </section>
  );
};

export default CalculatorHero;
